import { ObjectValuesType } from '../helpers/utilities';

export const StructureFieldTypes = {
  CONTAINER: 'container',
  ATTACHMENT: 'attachment',
  ATTACHMENT_3: 'attachment_3.0',
  TEXT: 'text',
  TEXTAREA: 'textarea',
  FILE: 'file',
  BOOLEAN: 'boolean',
  HTML: 'html',
  PHONE: 'phone',
  EMAIL: 'email',
  SELECT: 'select',
  PRIVACY: 'privacy',
  QRCODE: 'qrcode',
  HOTSPOTTER: 'hotspotter',
  IMAGE_MAP_CONTAINER: 'imageMapContainer',
  FEATURE_VALUES_CONTAINER: 'featureValuesContainer',
  FEATURE_VALUES_WITH_PARENT: 'featureValuesWithParent',
  RELATED_ENTITIES: 'relatedEntities',
  DATE: 'date',
  TIME: 'time',
  CALCULATED: 'calculated',
  NUMBER: 'number',
  RELATED_POSITIONING: 'relatedPositioning',
  MATERIAL: 'material',
  URLTITLE: 'urlTitle',
  SUBSTRUCTURE: 'substructure',
  CHIPS: 'chips',
} as const;

export const ContainerType = {
  CONTAINER: 'container',
  ATTACHMENT: 'attachment',
  IMAGE_MAP_CONTAINER: 'imageMapContainer',
} as const;

export type StructureFieldTypes = ObjectValuesType<typeof StructureFieldTypes>;
export type ContainerType = ObjectValuesType<typeof ContainerType>;
